import {FormEvent, useState} from "react";
import {validate} from "../../utils/validator";
import {isObjectEmpty} from "../../utils/object";
import {sendMail} from "../../utils/firebaseConfig";
import {RequestData} from "@functions/models";

const initialState: RequestData = {
  boatName: "",
  details: [{job: "", brief: ""}],
  email: "",
  extraDetails: "",
  firstName: "",
  lastName: "",
  number: "",
};

export default function useViewModel() {
  const validations = {};

  const [data, setData] = useState<RequestData>(initialState);
  const [formSuccessMessage, setFormSuccessMessage] = useState<string | null>(null);
  const [formFailureMessage, setFormFailureMessage] = useState<string | null>(null);
  const [isBusy, setIsBusy] = useState(false);
  const [formClosed, setFormClosed] = useState(false);

  function handleChange(tag: string) {
    return function(value: string) {
      setData((d) => ({...d, [tag]: value}));
    };
  }

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const errors = validate(data, validations);
    if (!isObjectEmpty(errors)) {
      return errors;
    }

    setIsBusy(true);

    try {
      const {data: response} = await sendMail(data);

      if (response.wasSuccessful) {
        setFormSuccessMessage("New work order added!");
      } else {
        setFormFailureMessage(`Submission failed! Cause: ${response.message}`);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setFormFailureMessage(`And unexpected error occurred! Email us directly at info@sterlingyachtservices.co.uk Cause: ${e?.message ?? "UNKNOWN"}`);
    } finally {
      setIsBusy(false);
    }
  }

  function addDetail() {
    setData({
      ...data,
      details: [
        ...data.details,
        {job: "", brief: ""},
      ],
    });
  }

  function deleteDetail(index: number) {
    const newDetails = [...data.details];
    newDetails.splice(index, 1);
    setData({
      ...data,
      details: [
        ...newDetails,
      ],
    });
  }

  function handleDetailJobChange(index: number, value: string) {
    const newDetails = [...data.details];
    newDetails[index].job = value;
    setData({
      ...data,
      details: [
        ...newDetails,
      ],
    });
  }
  function handleDetailBriefChange(index: number, value: string) {
    const newDetails = [...data.details];
    newDetails[index].brief = value;
    setData({
      ...data,
      details: [
        ...newDetails,
      ],
    });
  }

  function onSuccessDismiss() {
    setFormSuccessMessage(null);
    setFormClosed(true);
  }

  function onFailureDismiss() {
    setFormFailureMessage(null);
  }

  return {
    validations,
    data,
    addDetail,
    deleteDetail,
    handleDetailTitleChange: handleDetailJobChange,
    handleDetailDescChange: handleDetailBriefChange,
    handleChange,
    onSubmit,
    formSuccessMessage,
    formFailureMessage,
    isBusy,
    onSuccessDismiss,
    onFailureDismiss,
    formClosed,
  };
}

